import { render, staticRenderFns } from "./NosologiesListWithSelect.vue?vue&type=template&id=78136696&"
import script from "./NosologiesListWithSelect.vue?vue&type=script&lang=js&"
export * from "./NosologiesListWithSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports